<template>
  <section class="section">
    <div class="container-lg">
      <div class="row">
        <div class="col-md-8">
          <div class="section__header">
            <h1 class="section__title  section__title--lg">
              {{ page_title }}
            </h1>
          </div>
        </div><!-- /.col -->
        <div class="col-md-4">
          <catalog-sort
              v-if="products.length > 0"
              :display="display"
              :in18="in18"
              @change-filter="handleFilterChange"
              @display-changed="handleDisplayModeChange"
          />
        </div><!-- /.col -->
      </div><!-- /.row -->
      <div class="row  mt-5">
        <catalog-products
            :in18="in18"
            :display="display"
            :isLoading="isLoading"
            :pagination="pagination"
            :products="products"
            :is_wishlist_page="is_wishlist_page"
            @change-page="handlePageChange"
        />
      </div><!-- /.row -->
    </div>
  </section>
</template>

<script>

import axios from "axios";
import CatalogSort from "../components/catalog/CatalogSort.vue";
import CatalogProducts from "../components/catalog/CatalogProducts.vue";
import {DEFAULT_CATALOG_PARAMS} from "../config";

export default {
  name:       "Search",
  components: {
    'catalog-sort':     CatalogSort,
    'catalog-products': CatalogProducts,
  },
  props:      {
    in18:             Object,
    query_params:     Object,
    page_title:       String,
    is_wishlist_page: {
      type:    Boolean,
      default: false
    },
  },
  created() {
    // Fetch filtered products when the component is created.
    this.fetchFilteredProducts();
  },
  data() {
    return {
      isLoading:  true,
      products:   {},
      display:    'grid',
      params:     {
        ...DEFAULT_CATALOG_PARAMS,
      },
      pagination: {
        links: {},
        meta:  {},
      },
    };
  },

  methods: {

    /**
     * Fetch filtered products based on additional query parameters.
     */
    fetchFilteredProducts() {

      // Show loading indicator.
      this.isLoading = true;
      // Combine default and query parameters.
      const params = {...this.params, ...this.query_params};

      // Make an API request to fetch products.
      axios.get("/api/search/products", {params})
          .then((response) => {
            // Update product data and pagination.
            this.products = response.data.collection.data.products;
            this.pagination = {
              links: response.data.collection.links,
              meta:  response.data.collection.meta,
            };
            ga_view_item_list_event(response.data.collection.data.products);
          })
          .catch((error) => {
            console.error(error.response);
            window.toastr.error(error.response.data.message);
          })
          .finally(() => {
            // Hide loading indicator.
            this.isLoading = false;
          });
    },

    /**
     * Handle a change in filter criteria.
     *
     * This method is used to update the filter criteria and trigger a product
     * filtering operation. It sets the page to 1, updates the specified filter
     * property, updates the URL, and fetches filtered products.
     *
     * @param {string} prop - The filter property to change.
     * @param {any} value - The new value for the filter property.
     */
    handleFilterChange(prop, value) {
      this.params.page = 1;
      this.params[prop] = value;
      window.updateURL(this.params);
      this.fetchFilteredProducts();
    },

    /**
     * Handle a change in the current page.
     *
     * This method is used to update the current page number and trigger a product
     * pagination operation. It updates the page number, updates the URL, and
     * fetches products for the new page.
     *
     * @param {number} page - The new page number.
     */
    handlePageChange(page) {
      this.params.page = page;
      window.updateURL(this.params);
      this.fetchFilteredProducts();
    },

    /**
     * Handle a change in the display mode.
     * @param {string} display - The new display mode (e.g., 'grid' or 'list').
     */
    handleDisplayModeChange(display) {
      this.display = display;
    },
  },
};
</script>